module.exports = __webpack_public_path__ + "img/banner-good-health-and-well-being.abcd199a.png";